module.exports = __webpack_public_path__ + "img/teacat_img_not_found.31954c71.png";